/**
 * Created by Mark on 17/04/2017.
 */


import { EventEmitter } from 'events';
import AppDispatcher from '../applciation-dispatcher.js';

export default class BaseStore extends EventEmitter {

    subscribe(actionSubscribe) {
        this._dispatchToken = AppDispatcher.register(actionSubscribe());
    }

    get dispatchToken() {
        return this._dispatchToken;
    }

    emitChange() {
        this.emit('CHANGE');
    }

    addChangeListener(cb) {
        this.on('CHANGE', cb)
    }

    removeChangeListener(cb) {
        this.removeListener('CHANGE', cb);
    }
}